import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

// import TX from '@Components/Common/Text';
import TextCSS from '@Components/Common/Text/Styles';
import TextArea from '@Components/Common/TextArea';

// import { ReactComponent as LinkSVG } from '@Assets/Svgs/ic_link.svg';
const ACHIEVEMENT_KEYS = {
  TITLE: 'title',
  DESCRIPTION: 'description',
  CONDITION: 'condition',
};

const MultipleTextArea = ({
  // isUsingAchievementChip,
  isReadMode,
  // targetLinkedProcessId,
  achievementId,
  title,
  description,
  condition,
  handleChangeAchievementText,
}) => {
  // const isShowLinkedProcessId = targetLinkedProcessId !== null && isUsingAchievementChip;

  return (
    <TextAreaContainer>
      <TextArea
        isFocus
        readOnly={isReadMode}
        value={title}
        placeholder="새로운 업적"
        lineHeight={20}
        fontCSS={TextCSS.Title3}
        onChange={event => handleChangeAchievementText(achievementId, ACHIEVEMENT_KEYS.TITLE, event)}
        onKeyDowntrue
      >
        {/* {isShowLinkedProcessId ? (
          <LinkedContainer>
            <LinkedIcon />
            <LinkedText>{targetLinkedProcessId}p</LinkedText>
          </LinkedContainer>
        ) : null} */}
      </TextArea>

      <TextArea
        readOnly={isReadMode}
        value={description}
        placeholder="업적 설명을 입력하세요"
        lineHeight={16}
        fontCSS={TextCSS.FootnoteM}
        onChange={event => handleChangeAchievementText(achievementId, ACHIEVEMENT_KEYS.DESCRIPTION, event)}
        onKeyDowntrue
      />
      <TextArea
        isGray
        readOnly={isReadMode}
        value={condition}
        placeholder="힌트를 입력하세요"
        lineHeight={16}
        fontCSS={TextCSS.Caption1}
        onChange={event => handleChangeAchievementText(achievementId, ACHIEVEMENT_KEYS.CONDITION, event)}
        onKeyDowntrue
      />
    </TextAreaContainer>
  );
};

MultipleTextArea.propType = {
  isUsingAchievementChip: PropTypes.bool.isRequired,
  isReadMode: PropTypes.bool.isRequired,
  targetLinkedProcessId: PropTypes.number,
  achievementId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  condition: PropTypes.string.isRequired,
  handleChangeAchievementText: PropTypes.func.isRequired,
};

MultipleTextArea.defaultProps = {
  targetLinkedProcessId: null,
};

const TextAreaContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1;

  gap: 8px 0px;
`;

// const LinkedContainer = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;

//   margin-right: 10px;
// `;

// const LinkedIcon = styled(LinkSVG)`
//   width: 16px;
//   height: 16px;
// `;

// const LinkedText = styled(TX.FootnoteM)`
//   color: ${({ theme }) => theme.colors.ui_on_3};
// `;

export default MultipleTextArea;
